import React from 'react';

// import { getRatingDetails, updateRatingObject, getMatchTypeIndicator } from '../../../utils';

class Description extends React.Component {
    // constructor(props) {
    //     super(props);
    // }

    render() {
        const { desc, noellipsis } = this.props;
        let description;

        function createDescriptionFromArray(arr) {
            // return arr.join(' \u00B7 ');
            return arr.filter(Boolean).join(' \u2022 ');
        }
        if (typeof desc === 'string' || typeof desc === 'number') {
            description = desc;
        } else if (typeof desc === 'object') {
            description = createDescriptionFromArray(desc);
        }
        if (noellipsis) {
            return (
                <span dangerouslySetInnerHTML={{ __html: description }} />
            );
        }
        return (
            <span className="show-ellipsis" dangerouslySetInnerHTML={{ __html: description }} />
        );
    }
}

export default Description;
